<template>
	<el-row :gutter="20">
		<el-col :span="8">
			<div>
				<el-statistic>
					<template slot="title">
						<div>
							<span>处理单量【单】</span>
							<el-tooltip class="item" effect="dark" content="入库单业务日期等于预计到货日期的入库数量" placement="right">
								<i class="el-icon-question" style="margin-left: 4px;"></i>
							</el-tooltip>
						</div>
					</template>
					<template slot="formatter">
						{{statics.instocksize}}
					</template>
				</el-statistic>
			</div>
		</el-col>
		<el-col :span="8">
			<div>
				<el-statistic>
					<template slot="title">
						<span>处理重量【kg】</span>
						<el-tooltip class="item" effect="dark" content="入库单业务日期等于预计到货日期的入库重量" placement="right">
							<i class="el-icon-question" style="margin-left: 4px;"></i>
						</el-tooltip>
					</template>
					<template slot="formatter">
						{{statics.instockweight.toFixed(2)}}
					</template>
				</el-statistic>
			</div>
		</el-col>
		<el-col :span="8">
			<div>
				<el-statistic>
					<template slot="title">
						<span>在途单量【单】/重量【kg】</span>
						<el-tooltip class="item" effect="dark" content="预计到货日期大于当前日期订单的数量/重量" placement="right">
							<i class="el-icon-question" style="margin-left: 4px;"></i>
						</el-tooltip>
					</template>
					<template slot="formatter">
						{{this.statics.inwaysize+'/'+this.statics.inwayweight}}
					</template>
				</el-statistic>
			</div>
		</el-col>
	</el-row>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	export default {
		props: {
			warehouse: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				statics: {
					instocksize: 0,
					instockweight: 0,
					inwaysize: 0,
					inwayweight: 0,
				}
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			this.load()

		},
		computed: {

		},

		methods: {
			load() {
				this.$api.warehousepurchase.statics({
					warehouse:this.warehouse
				}).then((res) => {
					this.statics.instocksize = parseFloat(res.instocksize)
					this.statics.instockweight = parseFloat(res.instockweight)
					this.statics.inwaysize = parseFloat(res.inwaysize)
					this.statics.inwayweight = parseFloat(res.inwayweight).toFixed(2)
					// console.log(res)
				})
			}

		},
		components: {

		}
	}
</script>